var req = require("!!/app/node_modules/pug-loader/index.js??ref--13-1!/app/src/linagora.esn.contact/app/contact/list/contact-list.pug");
module.exports = (req['default'] || req).apply(req, [])